export const RELEASE_STATUS = {
  draft: { label: "Borrador", group: "draft", dot: "#F59E0B", cls: "border-amber-300 bg-amber-50 text-amber-800" },
  in_review: { label: "Revisión ≤72 h", group: "review", dot: "#3B82F6", cls: "border-blue-300 bg-blue-50 text-blue-700" },
  processing: { label: "En camino a tiendas", group: "review", dot: "#3B82F6", cls: "border-blue-300 bg-blue-50 text-blue-700" },
  needs_correction: { label: "Acción requerida", group: "action", dot: "#EF4444", cls: "border-red-300 bg-red-50 text-red-700" },
  takedown: { label: "Retirado", group: "action", dot: "#EF4444", cls: "border-red-300 bg-red-50 text-red-700" },
  approved: { label: "Aprobado", group: "live", dot: "#10B981", cls: "border-emerald-300 bg-emerald-50 text-emerald-700" },
  distributed: { label: "En tiendas", group: "live", dot: "#10B981", cls: "border-emerald-300 bg-emerald-50 text-emerald-700" },
};

// Traffic-light groups used across the catalog (dot + accent bar).
export const RELEASE_GROUPS = {
  draft: { label: "Borradores", bar: "bg-amber-400", dot: "#F59E0B" },
  review: { label: "En revisión", bar: "bg-blue-400", dot: "#3B82F6" },
  action: { label: "Acción requerida", bar: "bg-red-500", dot: "#EF4444" },
  live: { label: "En tiendas", bar: "bg-emerald-400", dot: "#10B981" },
};

export const releaseGroup = (status) => RELEASE_STATUS[status]?.group || "review";

export const SESSION_STATUS = {
  pending_signatures: { label: "Pendiente de firmas", cls: "border-amber-300 bg-amber-50 text-amber-700" },
  sealed: { label: "Sellado", cls: "border-emerald-300 bg-emerald-50 text-emerald-700" },
};

export const COVER_REQUEST_STATUS = {
  pending_verification: { label: "Pago en verificación", dot: "#F59E0B", cls: "border-amber-300 bg-amber-50 text-amber-800" },
  verified: { label: "Pago verificado", dot: "#3B82F6", cls: "border-blue-300 bg-blue-50 text-blue-700" },
  in_design: { label: "En diseño", dot: "#8B5CF6", cls: "border-violet-300 bg-violet-50 text-violet-700" },
  delivered: { label: "Entregado", dot: "#10B981", cls: "border-emerald-300 bg-emerald-50 text-emerald-700" },
  rejected: { label: "Rechazado", dot: "#EF4444", cls: "border-red-300 bg-red-50 text-red-700" },
};

export const StatusBadge = ({ map, status, fallbackLabel }) => {
  const cfg = map[status] || { label: fallbackLabel || status, cls: "border-slate-300 bg-slate-50 text-slate-600" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold ${cfg.cls}`}
    >
      {cfg.dot && <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: cfg.dot }} />}
      {cfg.label}
    </span>
  );
};
